import { Link } from 'react-router-dom';
import './TestIt.css';

function TestIt() {
  return (
    <div className='test-it'>
      <div>
        <p className='title white'>Can I test it out?</p>
        
        <p className='description white medium'>
        Of course! Use our debt payoff calculator to see how much time and money you can save eliminating your debt with Sera.
        </p>

        <Link to='/debt-payoff-calculator'>
          <button  className='link white first'>
            Calculate my payments
          </button>
        </Link>
      </div>
      <div className='graph-container'>
        <img className='graph' alt='' />
      </div>
      <Link to='/debt-payoff-calculator'>
        <button  className='link white second'>
          Calculate my payments
        </button>
      </Link>
    </div>
  )
}

export default TestIt;